import { Box, Button, type ButtonProps, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import type { NavLinkProps } from "react-router";

export const Root = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  borderBottom: `1px solid ${theme.palette.divider}`,
  paddingTop: theme.spacing(0.5),
  paddingBottom: theme.spacing(0.5),
  paddingLeft: 0,
  paddingRight: 0,
  [theme.breakpoints.down("sm")]: {
    paddingLeft: theme.spacing(0.5),
    paddingRight: theme.spacing(0.5),
  },
}));

export const Container = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  flex: 1,
  gap: theme.spacing(0.5),
  [theme.breakpoints.down("sm")]: {
    gap: theme.spacing(0.25),
  },
}));

export const CategoryWrapper = styled(Box)({
  display: "flex",
  alignItems: "center",
});

export const CategoryButton = styled(Button)<
  ButtonProps & Partial<NavLinkProps> & { $isActive: boolean }
>(({ theme, $isActive }) => ({
  minWidth: "auto",
  paddingLeft: theme.spacing(1),
  paddingRight: theme.spacing(1),
  paddingTop: theme.spacing(1.25),
  paddingBottom: theme.spacing(1.25),
  textTransform: "none",
  borderRadius: $isActive ? 0 : theme.spacing(1.5),
  borderBottom: $isActive
    ? `0.125rem solid ${theme.palette.text.primary}`
    : "none",
  backgroundColor: "transparent",
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(0.5),
  textDecoration: "none",
  color: "inherit",

  "&:hover": {
    backgroundColor: "transparent",
    textDecoration: "none",
  },
  "&.active": {
    borderBottom: `0.125rem solid ${theme.palette.text.primary}`,
  },
}));

export const CategoryText = styled(Typography)<{ $isActive: boolean }>(
  ({ theme, $isActive }) => ({
    textWrap: "nowrap",
    fontWeight: $isActive ? 700 : 500,
    color: $isActive
      ? theme.palette.text.primary
      : theme.palette.text.secondary,
  })
);
